import { render, staticRenderFns } from "./education-manage-modal.vue?vue&type=template&id=6b812e75&scoped=true&"
import script from "./education-manage-modal.vue?vue&type=script&lang=js&"
export * from "./education-manage-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b812e75",
  null
  
)

export default component.exports